export default function Footer(){
  return (
    <footer className="container" style={{opacity:.7, marginTop: 40, paddingBottom: 30}}>
      © {new Date().getFullYear()} El Show de las Banqueras
    </footer>
  );
}
